export default __webpack_public_path__ + "static/media/document-icon.2b5508f7.svg";